<template>
  <v-card class="create-sor">
    <v-card-title>
      {{ $t('sor.create_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-radio-group v-model="result.type"
                       :label="$t('sor.type')">
          <v-radio :label="$t('sor_type.SOR')"
                   :value="SOR_TYPE.SOR"></v-radio>
          <v-radio :label="$t('sor_type.CORRIGENDUM')"
                   :value="SOR_TYPE.CORRIGENDUM"></v-radio>
        </v-radio-group>
        <v-select outlined
                  clearable
                  :label="$t('sor.previous_version')"
                  :items="previousVersionOptions"
                  v-model="result.previous_version"
                  :rules="result.type === SOR_TYPE.CORRIGENDUM ? requiredRules: []"></v-select>
        <v-combobox outlined
                    :label="$t('edition.id')"
                    :items="editions"
                    v-model="result.edition_id"
                    :rules="requiredRules"></v-combobox>
        <v-text-field outlined
                      :label="$t('sor.name')"
                      v-model="result.name"
                      :rules="requiredRules"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && save()"
             depressed
             large>
        {{ $t('ok') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import {SOR_TYPE} from "@/constants";

export default {
  name: 'CreateSorDialog',
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);

    const editions = ref([]);
    const isNewEdition = computed(() => editions.value.indexOf(result.value.edition) === -1)
    const getEditions = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/edition/',
        params: {
          page_size: -1,
        },
      });

      if (response.body.success) {
        editions.value = response.body.editions.map((e) => e.id);
      }
    }

    const sors = ref([]);
    const getSors = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/',
        params: {
          page_size: -1,
          filters: {
            // 'next_version': false,
            'type': [SOR_TYPE.SOR, SOR_TYPE.CORRIGENDUM],
            'action_input_finalised_at': true,
          }
        }
      });

      if (response.body.success) {
        sors.value = response.body.sors;
      }
    }
    const previousVersionOptions = computed(() => {
      return sors.value.map((s) => {
        return {text: s.name, value: s.id}
      })
    })

    const result = ref({
      edition: '',
      name: '',
      type: SOR_TYPE.SOR,
      previous_version: null,
    })

    const save = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/sor/create/',
        params: {
          ...result.value,
        }
      });

      if (response.body.success) {
        emit('submit', response.body.sor.id)
      }
    }

    onMounted(() => {
      getEditions()
      getSors();
    })

    return {
      requiredRules,
      editions,
      isNewEdition,
      previousVersionOptions,
      result,
      save,
      SOR_TYPE,
    }
  },
}
</script>
